import Header from '../components/Header';
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';

/**
 * MainLayout component that provides a consistent structure for all pages
 * Includes Header, content area, Newsletter and Footer
 */
const MainLayout = ({ children, skipNewsletter, newsletterId }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex-grow">
        {children}
      </div>
      {!skipNewsletter && <Newsletter id={newsletterId} />}
      <Footer />
    </div>
  );
};

export default MainLayout; 